"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _StripeCheckoutForm = _interopRequireDefault(require("../../../core/StripeCheckoutForm"));
var _StripePaymentContainer = _interopRequireDefault(require("../../../core/StripePaymentContainer"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  providingNewPaymentDetails: false,
  error: null
};
var _ref = /*#__PURE__*/_react.default.createElement("h5", {
  className: "card-header"
}, "Card Details");
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
var _ref4 = /*#__PURE__*/_react.default.createElement("div", {
  className: "card-header lead"
}, "New Payment Details");
var _ref5 = /*#__PURE__*/_react.default.createElement("p", null, "All entries were cancelled and refunded before your credit card was charged.");
var _ref6 = /*#__PURE__*/_react.default.createElement("p", {
  className: "text-warning"
}, "An error was encountered trying to charge your card. We will try again in the next 24 hours");
var _ref7 = /*#__PURE__*/_react.default.createElement("p", {
  className: "text-danger"
}, "We have been unable to charge your card. Please submit new payment details via the \"FAILED PAYMENTS\" option in the menu above. The organiser may cancel your entry if you do not do so.");
var _ref8 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Date"), /*#__PURE__*/_react.default.createElement("th", null, "Amount")));
var _ref9 = /*#__PURE__*/_react.default.createElement("h5", {
  className: "card-header"
}, "Entries");
var _ref10 = /*#__PURE__*/_react.default.createElement("p", null, "These are all the entries covered by the authorised payment");
var _ref11 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Race"), /*#__PURE__*/_react.default.createElement("th", null, "Day"), /*#__PURE__*/_react.default.createElement("th", null, "Paddler"), /*#__PURE__*/_react.default.createElement("th", null, "Entry Status")));
class PaymentDetailModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleNewPaymentDetails", () => {
      const providingNewPaymentDetails = !this.state.providingNewPaymentDetails;
      this.setState({
        providingNewPaymentDetails
      });
    });
    _defineProperty(this, "_displayPaymentCard", payment => {
      if (payment.paymentCard && payment.paymentStatusRef !== 'CANC') return /*#__PURE__*/_react.default.createElement("div", {
        className: "card"
      }, _ref, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-block"
      }, /*#__PURE__*/_react.default.createElement("p", null, "This payment", payment.paymentStatusRef === 'PAID' || payment.paymentStatusRef === 'ERR' ? ' was ' : ' will be ', "charged to:", _ref2, payment.paymentCard.brand, ": **** **** **** ", payment.paymentCard.last4, _ref3, "Expiry Date: ", payment.paymentCard.expMonth, "/", payment.paymentCard.expYear), payment.paymentStatusRef === 'PAID' || payment.chargeID ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "info",
        onClick: this._onToggleNewPaymentDetails
      }, this.state.providingNewPaymentDetails ? 'Hide New Card Details' : 'Update Card Details for this Payment'), !this.state.providingNewPaymentDetails ? null : /*#__PURE__*/_react.default.createElement(_StripeCheckoutForm.default, {
        onCheckout: async ({
          paymentMethodID,
          setupIntentID
        }) => {
          return await this.props.onUpdatePaymentDetails(paymentMethodID, payment.id, setupIntentID);
        },
        onCheckoutSuccess: () => this.setState({
          providingNewPaymentDetails: false
        }),
        onCheckoutError: error => this.setState({
          error
        })
      }, ({
        checkoutInProgress
      }) => /*#__PURE__*/_react.default.createElement("div", {
        className: "card"
      }, _ref4, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-block"
      }, /*#__PURE__*/_react.default.createElement(_StripePaymentContainer.default, {
        submitButtonLabel: "Confirm Update",
        loading: checkoutInProgress
      }))))));
    });
    _defineProperty(this, "_onClearClose", () => {
      if (this.state.error) return this.setState({
        error: null
      });
      this.props.onClose();
    });
  }
  _getPaymentStatement(payment) {
    switch (payment.paymentStatusRef) {
      case 'CANC':
        return _ref5;
      case 'PAID':
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "text-success"
        }, "Your card was successfully charged ", (0, _gbp.default)(payment.paidAmount), " on", ' ', (0, _occasion.default)(payment.paidDate.split('T')[0], 'D MMMM'));
      case 'ACPT':
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "text-warning"
        }, "Your card will be charged ", (0, _gbp.default)(payment.expectedAmount - payment.refundedByClubPreCharge), " on or around", ' ', (0, _occasion.default)(payment.competition.paymentsChargeDate, 'D MMMM'));
      case 'ERR1':
        return _ref6;
      case 'ERR':
        return _ref7;
      default:
        break;
    }
  }
  _displayRefunds(title, text, refunds) {
    if (refunds && refunds.length) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "card"
      }, /*#__PURE__*/_react.default.createElement("h5", {
        className: "card-header"
      }, title), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-block"
      }, /*#__PURE__*/_react.default.createElement("p", null, text), /*#__PURE__*/_react.default.createElement(_table.default, null, _ref8, /*#__PURE__*/_react.default.createElement("tbody", null, refunds.map(refund => /*#__PURE__*/_react.default.createElement("tr", {
        key: refund.id
      }, /*#__PURE__*/_react.default.createElement("td", null, refund.refundStatusDescription), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(refund.refundDate.split('T')[0], 'D MMMM')), /*#__PURE__*/_react.default.createElement("td", null, (0, _gbp.default)(refund.refundedByClub))))))));
    }
  }
  render() {
    const payment = this.props.paymentByID;
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: payment.paymentStatusDescription,
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onClearClose,
        type: "primary"
      }, "OK"),
      size: "lg",
      onClose: this._onClearClose
    }, this.state.error ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.error) : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Payment of ", (0, _gbp.default)(payment.expectedAmount), " was initially authorised on", ' ', (0, _occasion.default)(payment.createdDate.split('T')[0], 'D MMMM YYYY')), payment.refundedByClubPreCharge && payment.paymentStatusRef !== 'CANC' ? /*#__PURE__*/_react.default.createElement("p", null, (0, _gbp.default)(payment.refundedByClubPreCharge), " was refunded before your credit card was charged, reducing the expected payment to ", (0, _gbp.default)(payment.expectedAmount - payment.refundedByClubPreCharge)) : '', this._getPaymentStatement(payment), this._displayPaymentCard(payment), /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref9, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, _ref10, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref11, /*#__PURE__*/_react.default.createElement("tbody", null, payment.entries.map(entry => /*#__PURE__*/_react.default.createElement("tr", {
      key: entry.id
    }, /*#__PURE__*/_react.default.createElement("td", null, entry.race.raceName), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(entry.race.competitionDay.dayDate, 'dddd')), /*#__PURE__*/_react.default.createElement("td", null, "Bib ", entry.bibNumber, " - ", entry.bibName), /*#__PURE__*/_react.default.createElement("td", null, entry.entryStatusDescription))))))), this._displayRefunds('Refunds', 'These refunds will not show up on your card statement.', payment.refunds.filter(r => !(r.refundStatusRef === 'PEND') && !r.hasBeenRefundedThroughStripe)), this._displayRefunds('Refunds Processed Post-Charge', 'These refunds were processed after your card was charged and will be actioned after the competition.  They will then show up on your card statement.', payment.refunds.filter(r => r.refundStatusRef === 'PEND')), this._displayRefunds('Refunds Processed Post-Charge', 'These refunds were processed after your card was charged.  They will show up on your card statement.', payment.refunds.filter(r => r.hasBeenRefundedThroughStripe))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref12 = {
  id: true,
  expectedAmount: true,
  refundedByClubPreCharge: true,
  paidAmount: true,
  paidDate: true,
  paymentStatusRef: true,
  paymentStatusDescription: true,
  createdDate: true,
  paymentCard: true,
  chargeID: true,
  competition: {
    competitionName: true,
    paymentsChargeDate: true
  },
  refunds: {
    id: true,
    refundedByClub: true,
    refundDate: true,
    hasBeenRefundedThroughStripe: true,
    refundStatusRef: true,
    refundStatusDescription: true
  },
  entries: {
    id: true,
    bibNumber: true,
    bibName: true,
    entryStatusDescription: true,
    race: {
      raceName: true,
      competitionDay: {
        dayDate: true
      }
    }
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(PaymentDetailModal, props => ({
  ["paymentByID(paymentID:" + JSON.stringify(+props.paymentID) + ")"]: _ref12
}), (client, props) => ({
  onUpdatePaymentDetails(token, paymentID, setupIntentID) {
    return client.update('Payment.updatePaymentDetails', {
      token,
      paymentID,
      setupIntentID
    });
  }
}));